import React, { useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { useTranslation } from 'react-i18next'
import { getmyevents, getnearby } from '../../utils/api'
import { getSourceMapRange } from 'typescript';
import { divide, get } from 'lodash';
import { useSearchParams } from 'react-router-dom'
import axios from 'axios';
import { Toast } from 'zarm';
import dw2 from '../../static/img/dw2.png';
import dqwz from '../../static/img/dqwz.png';
import { gettime } from '../../utils/time'
import { key } from './key'


const Plat: React.FC = () => {
  const { t } = useTranslation()
  const [map, setMap] = useState<google.maps.Map>();
  const [directions, setDirections] = useState<google.maps.DirectionsResult>(); const mapRef = useRef<HTMLDivElement>(null);
  const [center, setCenter] = useState({ lat: 37.77559046201275, lng: -122.42160803531742 });
  const [search, setsearch] = useSearchParams()
  const nameLocation = search.get("eventName") + ',' + search.get("eventLocation")
  const [distance, setdistance] = useState() as any
  const [drivingtime, setdrivingtime] = useState() as any
  const [activity, setactivity] = useState() as any
  const [Travelmode, setTravelmode] = useState('Drive')
  const [navigationroute, setnavigationroute] = useState([]) as any
  const [show, setshow] = useState(false)

  const [upcoming, getupcoming] = useState([]) as any;





  const Directions = (lat: any, lng: any) => {
    setshow(!show)
    // const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    // window.location.assign(url);
  };

  const [sdmUserId, setsdmUserId] = useState('');
  let sdmUserIdref = useRef('')
  useEffect(() => {
    sdmUserIdref.current = sdmUserId
  }, [sdmUserId])


  const goBackPage = () => {
    window.history.back()
  }


  function handleLocationError(
    browserHasGeolocation: boolean,
    infoWindow: google.maps.InfoWindow,
    pos: google.maps.LatLng
  ) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(
      browserHasGeolocation
        ? "Error: The Geolocation service failed."
        : "Error: Your browser doesn't support geolocation."
    );
    infoWindow.open(map);
  }





  const getDistances = (lat1: any, lng1: any, lat2: any, lng2: any) => {
    let EARTH_RADIUS = 6378.137;// 地球半径
    let radLat1 = lat1 * Math.PI / 180.0; //lat1 * Math.PI / 180.0=>弧度计算
    let radLat2 = lat2 * Math.PI / 180.0;
    let a = radLat1 - radLat2;
    let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;// 输出为公里
    // return Number(s.toFixed(2))  
  }


  let activityRef: any = useRef()
  useEffect(() => {
    activityRef.current = activity
  }, [activity])

  const allmap = () => {

    console.log(AllactivitiesRef.current)
    const data: any = []
    if(AllactivitiesRef.current.length>0){
      AllactivitiesRef.current.forEach((item2: any, index: number) => {
        const pos: any = [{
          lat: Number(item2.latitude,),
          lng: Number(item2.longitude)
        }]
        let name =
          '<div id="content">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<h2 id="firstHeading" class="firstHeading">' + item2.eventName + '</h2>' +
          '<div id="bodyContent">' +
          "<p>" + item2.time + "</p>" +
          '<p>' + item2.eventLocation + "</p>" +
          "</div>" +
          "</div>";
  
        data[index] = pos
        data[index].push(name)
        data[index].push(item2.eventName)
        activityRef.current = data
        setactivity(activityRef.current)
      })
      getmaps(Number(AllactivitiesRef.current[0].latitude), Number(AllactivitiesRef.current[0].longitude), 1)
    }else{
      Toast.show(t('Therearenoactivitiesnearby'));
    }
 


   
  }


  const getmaps = (lat: any | null, lng: any | null, type: number | null) => {
    setshow(false)
    const loader = new Loader({
      apiKey: key,
      version: 'weekly',
      language: 'en-US'
    });

    loader.load().then(() => {
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            let longitude = 0
            let latitude = 0


            if (lat && lng) {
              longitude = lng
              latitude = lat
            } else {
              longitude = Number(search.get("longitude"))
              latitude = Number(search.get("latitude"))
            }

            const google = window.google;
            const map = new google.maps.Map(mapRef.current!, {
              center: { lat: latitude, lng: longitude, },
              zoom: 15,
              // mapTypeId: google.maps.MapTypeId.TERRAIN
            });
            setMap(map);

            console.log(latitude, longitude)
            // const positions = {
            //   lat: latitude,
            //   lng: longitude
            // }

            // const contentString = '<div id="content">' +
            //   '<div id="siteNotice">' +
            //   "</div>" +
            //   '<h2 id="firstHeading" class="firstHeading">' + search.get("eventName") + '</h2>' +
            //   '<div id="bodyContent">' +
            //   "<p>" + search.get("time") + "</p>" +
            //   '<p>' + search.get("eventLocation") + "</p>" +
            //   "</div>" +
            //   "</div>";



            const tourStops: [google.maps.LatLngLiteral, string,string][] = activityRef.current
            // const infoWindow = new google.maps.InfoWindow();
            var MarkerWithLabel = require("markerwithlabel")(google.maps);
            tourStops.forEach(([position, title,name], i) => {
              // bounds.extend(new google.maps.LatLng(position.lat, position.lng));
              // const marker: any = new google.maps.Marker({
              //   position,
              //   map,
              //   title: title,
              //   optimized: false,
              // });


              const marker = new MarkerWithLabel({
                position,
                title: title,
                draggable: false, //不可拖动
                map: map, //地图实例
                labelContent: name, //label的内容
                icon: dw2,
                labelAnchor: new google.maps.Point(-15, 35),
                labelStyle: {
                  padding: "5px 10px",
                  textAlign: "center",
                  fontWeight: '900',
                  color: 'rgb(85,137,195)',
                  // height:'30px',
                  // lineHeight:'30px',
                  border: '2px solid rgb(85,137,195)',
                  borderRadius: '5px',
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  width: '120px',
                  opacity: 1
                },
              });



              let travelMode = google.maps.TravelMode.DRIVING
              if (type == 1) {
                setTravelmode('Drive')
                travelMode = google.maps.TravelMode.DRIVING
              } else if (type == 2) {
                setTravelmode('Take bus')

                travelMode = google.maps.TravelMode.TRANSIT
              } else if (type == 3) {
                setTravelmode('RIDE')
                travelMode = google.maps.TravelMode.BICYCLING
              } else if (type == 4) {
                setTravelmode('Walk')
                travelMode = google.maps.TravelMode.WALKING
              }

              
              const directionsService = new google.maps.DirectionsService();
              const directionsRenderer = new google.maps.DirectionsRenderer({
                map,
                suppressMarkers: true
              });

              directionsService.route(
                {
                  origin: { lat: pos.lat, lng: pos.lng, },
                  destination: { lat: latitude, lng: longitude },
                  travelMode: travelMode
                },
                (result, status) => {
                  console.log(result)
                  if (status === google.maps.DirectionsStatus.OK) {
                    
                    const marker2 = new MarkerWithLabel({
                      position:{ lat: pos.lat, lng: pos.lng, },
                      draggable: false, //不可拖动
                      map: map, //地图实例
                      icon: dqwz,            
                    });


                    result.routes[0].legs[0].end_address=activityRef.current[0][1]
                    setdistance(result.routes[0].legs[0].distance.text)
                    setdrivingtime(result.routes[0].legs[0].duration.text)
                    
                    directionsRenderer.setDirections(result);
                 
                    setDirections(result);
                  } else {
                    setdistance('Sorry, no travel method results were found')
                    setdrivingtime('')
                  }
                }
              );

            


             

              setCenter(position)

              const infoWindow = new google.maps.InfoWindow();

              // const bounds = new google.maps.LatLngBounds();  

              marker.addListener("click", () => {


                directionsService.route(
                  {
                    origin: { lat: pos.lat, lng: pos.lng, },
                    destination: { lat: latitude, lng: longitude },
                    travelMode: travelMode
                  },
                  (result, status) => {

                    if (status === google.maps.DirectionsStatus.OK) {
                      console.log(result.routes[0].legs[0])
                      result.routes[0].legs[0].end_address = title
                      setdistance(result.routes[0].legs[0].distance.text)
                      setdrivingtime(result.routes[0].legs[0].duration.text)
                      setnavigationroute(result.routes[0].legs[0].steps)

                      const marker2 = new MarkerWithLabel({
                        position:{ lat: pos.lat, lng: pos.lng, },
                        draggable: false, //不可拖动
                        map: map, //地图实例
                        icon: dqwz,            
                      });

                      // marker.setMap(null);
                      directionsRenderer.setDirections(result);
                      setDirections(result);

              

                    } else {
                      setdistance('Sorry, no travel method results were found')
                      setdrivingtime('')
                    }
                  }
                );

                infoWindow.close();
                infoWindow.setContent(marker.getTitle());
                infoWindow.open(marker.getMap(), marker);
              });
            });


            // map.fitBounds(bounds);



            getDistances(latitude, longitude, pos.lat, pos.lng)

          },
          (e) => {
            console.log(e)
          }
        );
      } else {
        // Browser doesn't support Geolocation
      }

    });
  }


  const [Allactivities, setAllactivities] = useState([]) as any;
  const AllactivitiesRef = useRef(Allactivities);

  useEffect(() => {
    AllactivitiesRef.current = Allactivities
  }, [Allactivities])


  const getAllactivities = () => {

    let eventId = Number(search.get("eventId"))
    getnearby(eventId, 100, sdmUserIdref.current).then((res) => {
      AllactivitiesRef.current = res.data
      AllactivitiesRef.current.forEach((item:any)=>{
        item.time = gettime(item.eventStartTime, item.eventEndTime)
      })
    
      setAllactivities(AllactivitiesRef.current)
    })

  }


  useEffect(() => {
    window.scrollTo(0, 0);
    let data3: any = []
    data3 = localStorage.getItem('userinformation')
    data3 = JSON.parse(data3)
    sdmUserIdref.current = data3.userId


    const data: any = []

    const pos: any = [{
      lat: Number(search.get("latitude")),
      lng: Number(search.get("longitude"))
    }]
   let name= '<div id="content">' +
      '<div id="siteNotice">' +
      "</div>" +
      '<h2 id="firstHeading" class="firstHeading">' + search.get("eventName") + '</h2>' +
      '<div id="bodyContent">' +
      "<p>" + search.get("time") + "</p>" +
      '<p>' + search.get("eventLocation") + "</p>" +
      "</div>" +
      "</div>";
    data[0] = pos
    data[0].push(name)
    data[0].push(search.get("eventName"))

    activityRef.current = data
    setactivity(activityRef.current)
    getAllactivities()
    getmaps(null, null, 1)
  }, []);

  return <div style={{ height: '100vh', width: '100%', position: 'relative' }} >




    <div style={{
      backgroundColor: '#202225', width: '100%', height: '60px', display: 'flex', flexDirection: 'row',
      borderBottomColor: '#4747474D', borderBottomWidth: 1, zIndex: 9999,
    }}>
      {/* <div style={{ position: 'fixed', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', }}> */}
        <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', alignItems: 'center', cursor: 'pointer' }}>
          <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginRight: '10px' }} onClick={() => goBackPage()}></img>
          <div style={{ lineHeight: '60px', fontSize: '18px', fontWeight: 500, color: '#fff', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width:'60vw' }}>{search.get("eventName")}</div>
        </div>
        {/* <img src={require("../../static/img/map.png")} style={{ width: '24px', height: '24px', marginRight: '10px' }} onClick={() => allmap()}></img> */}
      {/* </div> */}

    </div>







    {show &&
      <div style={{ backgroundColor: "#fff", paddingTop: '20px', position: 'absolute', zIndex: 9999 }} onClick={() => Directions(center.lat, center.lng)}>
        {
          navigationroute.map((item: any, index: number) => <div key={index} style={{ fontSize: '16px', margin: '20px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', borderBottom: '1px solid #00aaff', paddingBottom: '5px' }}>
            <div dangerouslySetInnerHTML={{ __html: item.instructions }}></div>  travel {item.distance.text}  expected needs {item.duration.text}
          </div>
          )
        }
      </div>
    }

    <div ref={mapRef} style={{ height: '80vh', width: '100%', position: 'relative' }} >

    </div>

    <div style={{ backgroundColor: '#fff', zIndex: 1, width: '100%', padding: '15px', position: 'fixed', bottom: 0, height: '100vh-80vh-60px' }}>
      {/* <div style={{ backgroundColor: '#fff', zIndex: 999, width: '100%', padding: '20px', position: 'fixed', bottom: 0 }}> */}
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: '10px' }}>
        <div style={{ fontSize: '18px', fontWeight: 500 }}>{Travelmode} : {distance}</div>
        {drivingtime != '' &&
          <div style={{ fontSize: '18px', fontWeight: 500, marginLeft: '10px' }}>{drivingtime}</div>
        }
        {drivingtime != '' &&
          <div style={{ fontSize: '10px', marginLeft: '10px', color: '#00aaff', lineHeight: '24px', cursor: 'pointer' }} onClick={() => Directions(center.lat, center.lng)} >({t('startnavigation')})</div>
        }

      </div>



      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', cursor: 'pointer' }}>
        <div onClick={() => getmaps(center.lat, center.lng, 1)} style={{
          height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
          backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
        }}>{t('Drive')}</div>
        <div onClick={() => getmaps(center.lat, center.lng, 2)} style={{
          height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
          backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
        }}>{t('Takebus')}</div>
        <div onClick={() => getmaps(center.lat, center.lng, 3)} style={{
          height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
          backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
        }}>{t('RIDE')}</div>
        <div onClick={() => getmaps(center.lat, center.lng, 4)} style={{
          height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
          backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
        }}>{t('Walk')}</div>
      </div>

    </div>





  </div>;
};

export default Plat;



